import script from "./SummaryReportSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./SummaryReportSummary.vue?vue&type=script&setup=true&lang=js"

import "./SummaryReportSummary.vue?vue&type=style&index=0&id=37c3004a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c3004a"]])

export default __exports__